<template>
  <vk-modal v-bind="$attrs" v-on="$listeners">
    <vk-modal-body class="LOGIN-MODAL">
      <vk-modal-close class="MODAL-CLOSE-ICON p-2"/>
      <vk-modal-content class="d-flex jc-center">
        <transition name="fade" mode="out-in">
          <app-login-form
              :autoRedirect="autoRedirect"
              :redirectTo="redirectTo"
              :initial-email="initialEmail"
              @success="$emit('login-success', $event)">
            <alert-message v-if="showWelcomeMessage" slot="banner" type="success" class="m-b-3">
              Welcome back to Pro Referral. Please login below.
            </alert-message>
          </app-login-form>
        </transition>
      </vk-modal-content>
    </vk-modal-body>
  </vk-modal>
</template>

<script>
import AlertMessage from '@/components/AlertMessage';
import AppLoginForm from '@/components/AppLoginForm';

export default {
  name: 'login-modal',
  components: {
    AlertMessage,
    AppLoginForm,
  },
  props: {
    initialEmail: {
      type: String,
      default: '',
    },
    showWelcomeMessage: {
      type: Boolean,
      default: false,
    },
    autoRedirect: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    redirectTo () {
      return this.$route.fullPath;
    },
  },
  methods: {
    openForgotPassword (email) {
      this.$router.replace({ query: { email } }, () => {
        this.showForgotPassword = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools.scss";
 .MODAL-CLOSE-ICON {
    @include absolute(10px, 10px, auto, auto);
    z-index: 10;
  }
.LOGIN-MODAL {
  position: relative;
  @include tablet() {
    @include padding(2 4);
    min-width: auto;
    width: auto;
  }
}
</style>
